const answerReviewPermissions = {
    "answer-review": {
        index: (_session) => true,
        edit: (_session) => true,
        show: (_session) => true,
        new: (_session) => true,
        delete: (_session) => true,
        "mark-done": (_session, review) => {
            return !review.done;
        },
    },
};
export default answerReviewPermissions;
